import React from 'react';
import styled from 'styled-components';

import { WIDTH as QUOTE_IMAGE_WIDTH } from '../../components/QuoteImage';
import VerificationCode from '../../components/VerificationCode';

const VerificationCodePage = () => {
  return (
    <PageWrapper>
      <VerificationCode />
    </PageWrapper>
  );
};

const PageWrapper = styled.div`
  margin-top: 100px;

  @media ${({ theme }) => theme.queries.desktop} {
    margin-right: ${QUOTE_IMAGE_WIDTH};
  }
`;

export default VerificationCodePage;
